export enum enginTypes {
    LOADING = "LOADING",
    SELECTED_ENGIN = "SELECTED_ENGIN",
    GET_ENGIN_LIST = "GET_ENGIN_LIST",
    GET_INCIDENT_LIST = "GET_INCIDENT_LIST",
    GET_SYNTHESE_ENGIN = 'GET_SYNTHESE_ENGIN',
    GET_UTILISATION_BY_ENGIN = 'GET_UTILISATION_BY_ENGIN',
}
  
export default enginTypes;